import * as vueSentry from "@sentry/vue";
import * as baseSentry from "@sentry/browser";
import { isValidDSN, getDSN } from "./helper";
import { Integrations } from "@sentry/tracing";

let Sentry;
function syncConfigSentry(options, vueInstance = {}) {
  const { VUE_APP_SENTRY_DSN, VUE_APP_SENTRY_TSR, VUE_APP_ENV, VUE_APP_SENTRY_VERSION } = options || window.XCConfig || {};
  if (!isValidDSN(VUE_APP_SENTRY_DSN)) {
    console.warn(
      "Sentry 初始化失败, 引入了 @x-tech/fe-puma-lib-sentry-config 但并未在配置文件中设置 VUE_APP_SENTRY_DSN"
    );
  } else {
    const dsn = getDSN(VUE_APP_SENTRY_DSN);
    const sentryOptions = {
      dsn,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: Number(VUE_APP_SENTRY_TSR) || 0.5,
      environment: VUE_APP_ENV,
      autoSessionTracking: true
    };
    if (VUE_APP_SENTRY_VERSION) {
      sentryOptions.release = VUE_APP_SENTRY_VERSION;
    }
    if (vueInstance && vueInstance.version) {
      Sentry = vueSentry;
      const version = Number(vueInstance.version.split(".")[0]);
      sentryOptions[version <= 2 ? "Vue" : "app"] = vueInstance;

      if (version >= 3) {
        Sentry.attachErrorHandler(vueInstance, { logErrors: true });
        vueInstance.config.globalProperties.$_log = Sentry.captureMessage;
      } else {
        vueInstance.prototype.$_log = Sentry.captureMessage;
      }
    } else {
      Sentry = baseSentry;
    }
    Sentry.init(sentryOptions);
    Sentry.configureScope(function (scope) {
      scope.setTag("env", VUE_APP_ENV);
      scope.setTag("tracesSampleRate", `${(Number(VUE_APP_SENTRY_TSR) || 0.5) * 100}%`);
    });
  }
}

export { syncConfigSentry };
